import DashboardLayout from '@/layout/dashboard/DashboardLayout.vue'
// GeneralViews
import NotFound from '@/pages/NotFoundPage.vue'

// Admin pages
import Novidades from '@/pages/Novidades.vue'
import Recomendados from '@/pages/Recomendados.vue'
import Notifications from '@/pages/Notifications.vue'
import Icons from '@/pages/Icons.vue'
import Maps from '@/pages/Maps.vue'
import Typography from '@/pages/Typography.vue'
import TableList from '@/pages/TableList.vue'
import Busca from '@/pages/Busca.vue'
import Login from '@/pages/Login.vue'
import ChangePassword from '@/pages/ChangePassword.vue'
import ResetPassword from '@/pages/ResetPassword.vue'
import ForgotPassword from '@/pages/ForgotPassword.vue'
import EditBook from '@/pages/EditBook.vue'
import EditEmprestimo from '@/pages/EditEmprestimo.vue'
import NovoEmprestimo from '@/pages/NovoEmprestimo.vue'
import NovaReserva from '@/pages/NovaReserva.vue'
import Categorias from '@/pages/Categorias.vue'
import Editoras from '@/pages/Editoras.vue'
import Autores from '@/pages/Autores.vue'
import Colecoes from '@/pages/Colecoes.vue'
import Tags from '@/pages/Tags.vue'
import Emprestimos from '@/pages/Emprestimos.vue'
import Configuracoes from '@/pages/Configuracoes.vue'
import EditProfile from '@/pages/EditProfile.vue'
import Graficos from '@/pages/Graficos.vue'
import Book from '@/pages/Book.vue'
import Reservas from '@/pages/Reservas.vue'
import Estatisticas from '@/pages/Estatisticas.vue'
import Usuarios from '@/pages/Usuarios.vue'
import EditUser from '@/pages/EditUser.vue'

const routes = [
  {
    path: '/',
    component: DashboardLayout,
    redirect: '/busca',
    children: [
      {
        path: 'reservas',
        name: 'Reservas',
        component: Reservas
      },
      {
        path: 'graficos',
        name: 'Gráficos',
        component: Graficos
      },
      {
        path: 'editProfile',
        name: 'Editar Perfil',
        component: EditProfile
      },
      {
        path: 'configuracoes',
        name: 'configurações',
        component: Configuracoes
      },
      {
        path: 'emprestimos',
        name: 'empréstimos',
        component: Emprestimos
      },
      {
        path: 'editoras',
        name: 'editoras',
        component: Editoras
      },
      {
        path: 'autores',
        name: 'autores',
        component: Autores
      },
      {
        path: 'categorias',
        name: 'categorias',
        component: Categorias
      },
      {
        path: 'colecoes',
        name: 'coleções',
        component: Colecoes
      },
      {
        path: 'tags',
        name: 'tags',
        component: Tags
      },
      {
        path: 'login',
        name: 'login',
        component: Login
      },
      {
        path: 'passwordChange',
        name: 'Trocar Senha',
        component: ChangePassword
      },
      {
        path: 'reset/:token',
        name: 'Reset Senha',
        component: ResetPassword
      },
      {
        path: 'forgot',
        name: 'Esqueci Minha Senha',
        component: ForgotPassword
      },
      {
        path: 'addBook',
        name: 'Adicionar Livro',
        component: EditBook
      },
      {
        path: 'editBook/:id',
        name: 'Editar Livro',
        component: EditBook
      },
      {
        path: 'book/:id',
        name: 'Livro',
        component: Book
      },
      {
        path: 'editEmprestimo/:id',
        name: 'Editar Empréstimo',
        component: EditEmprestimo
      },
      {
        path: 'novoEmprestimo/:id',
        name: 'Emprestar Livro',
        component: NovoEmprestimo
      },
      {
        path: 'novaReserva/:id',
        name: 'Reservar Livro',
        component: NovaReserva
      },
      {
        path: 'busca',
        name: 'busca',
        component: Busca
      },
      {
        path: 'novidades',
        name: 'novidades',
        component: Novidades
      },
      {
        path: 'recomendados',
        name: 'recomendados',
        component: Recomendados
      },
      {
        path: 'notifications',
        name: 'notifications',
        component: Notifications
      },
      {
        path: 'icons',
        name: 'icons',
        component: Icons
      },
      {
        path: 'maps',
        name: 'maps',
        component: Maps
      },
      {
        path: 'typography',
        name: 'typography',
        component: Typography
      },
      {
        path: 'estatisticas',
        name: 'estatisticas',
        component: Estatisticas
      },
      {
        path: 'table-list',
        name: 'table-list',
        component: TableList
      },
      {
        path: 'usuarios',
        name: 'usuarios',
        component: Usuarios
      },
      {
        path: 'add-user',
        name: 'Adicionar Usuário',
        component: EditUser
      },
      {
        path: 'edit-user/:id',
        name: 'Editar Usuário',
        component: EditUser
      },
      
    ]
  },
  { path: '*', component: NotFound }
]

/**
 * Asynchronously load view (Webpack Lazy loading compatible)
 * The specified component must be inside the Views folder
 * @param  {string} name  the filename (basename) of the view to load.
function view(name) {
   var res= require('../components/Dashboard/Views/' + name + '.vue');
   return res;
};**/

export default routes
